import './index.css'

const Contact = () => (
  <div className="contact-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/contact-blog-img.png"
      alt="contact"
      className="contact-img"
    />
    <h1 className="contact-heading">Contact</h1>
    <p className="contact-heading">
      <span className="color1">Email:</span> dipXXXXX@gmail.com
    </p>
    <p className="contact-heading">
      <span className="color1">Mobile No:</span> 9876XXXXXX
    </p>
  </div>
)

export default Contact
